// Generated by scripts/generate.py. Do not edit.
export const ROLES = [
    "account_owner",
    "platform_admin",
];
